import MissionImage from "../../../assets/images/icons/mission.svg";
import VisionImage from "../../../assets/images/icons/vision.svg";
import ActivitiesImage from "../../../assets/images/icons/activity.svg";

const Entity = ({ data }) => {
  const entityCards = [
    {
      index: 0,
      image: MissionImage,
      title: "Mission",
      label: data?.mission,
    },
    {
      index: 1,
      image: VisionImage,
      title: "Vision",
      label: data?.vision,
    },
    {
      index: 2,
      image: ActivitiesImage,
      title: "Our Activities",
      label: data?.activity,
    },
  ];

  return (
    <div className=" lg:h-screen bg-blue-850 pb-10 lg:pb-0 pt-20">
      <h1 className="w-11/12 lg:w-5/6 mx-auto text-3xl lg:text-4xl xl:text-6xl uppercase text-white">
        The Entity is a corporate themed
      </h1>

      <div className="grid md:grid-cols-3 gap-10 md:gap-14 mb-40 cards px-5 lg:px-0 w-11/12 lg:w-4/5 xl:w-3/4 mx-auto mt-5">
        {entityCards.map((card) => (
          <div
            key={card.index}
            className="flex flex-col items-center justify-between relative overflow-hidden bg-blue-750 text-center text-white shadow-xl h-80 lg:h-100"
          >
            <div className="left-line1"></div>
            <div className="left-line2"></div>

            <div className="right-line1"></div>
            <div className="right-line2"></div>

            <div className="backdrop"></div>

            <div className="mt-12 md:mt-10 lg:mt-24 mb-4 lg:mb-8">
              <img src={card.image} alt={card.title} className="w-12" />
            </div>

            <div className="h-72 px-4 pb-2">
              <h3 className="text-2xl md:text-xl lg:text-2xl">{card.title}</h3>

              <p className="text-base md:text-sm lg:text-base break-all">
                {card.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Entity;
